import { generateMedia } from 'styled-media-query';

const breakpoints = {
  huge: '1440px',
  large: '1280px',
  medium: '1007px',
  small: '760px',
  extraSmall: '500px',
  mobile: '360px',
};

const media = generateMedia(breakpoints);

export default media;
export { breakpoints };
